/* React */
import React, { useRef, useEffect } from "react";

/* Ionic */
import { IonInput, InputInputEventDetail } from "@ionic/react";
import type { IonInputCustomEvent } from "@ionic/core";
import { search, close } from "ionicons/icons";

/* Component(s) */
import PrimaryFabButton from "src/components/shared/buttons/primary-fab-button/PrimaryFabButton";

/* Stylesheet */
import styles from "./Searchbar.module.scss";

/* Interface(s) */
interface SearchbarProps {
  scssProps?: ScssProps;
  showItems: boolean;
  showSearchbar: boolean;
  handleSearchbar: (value: boolean) => void;
  handleSearchTerm: (e: IonInputCustomEvent<InputInputEventDetail>) => void;
}

interface ScssProps {
  color?: string;
  background?: string;
}

const Searchbar: React.FC<SearchbarProps> = ({
  scssProps,
  showItems,
  showSearchbar,
  handleSearchbar,
  handleSearchTerm,
}) => {
  const inputRef = useRef<HTMLIonInputElement | null>(null);

  useEffect(() => {
    /**
     * setTimeout (a small delay) is required to ensure that the input field is focused,
     * when searchbar is opened. This is because Ionic handles rendering and updating
     * the virtual DOM different.
     *
     */
    let timer: NodeJS.Timeout;

    if (showSearchbar) {
      timer = setTimeout(() => {
        inputRef.current?.setFocus();
      }, 250);
    }

    return () => {
      clearTimeout(timer);
    };
  }, [showSearchbar]);
  return (
    <React.Fragment>
      {showItems && showSearchbar ? (
        <div
          style={{ background: scssProps?.background }}
          className={styles.searchbar}
        >
          <IonInput
            ref={inputRef}
            style={{
              color: scssProps?.color,
            }}
            className={styles.input}
            placeholder={"Search"}
            onClick={(e) => {
              e.stopPropagation();
            }}
            onIonInput={(e: IonInputCustomEvent<InputInputEventDetail>) =>
              handleSearchTerm(e)
            }
          />
        </div>
      ) : undefined}
      {showItems ? (
        <PrimaryFabButton
          scssProps={{
            position: "absolute",
            right: showSearchbar ? 0 : 36,
            margin: showSearchbar
              ? "0px 8px 0px 0px"
              : showItems
              ? "0px 16px 0px 0px"
              : "0px",
            color: scssProps?.color,
            background: "transparent",
            zIndex: 100,
          }}
          className={"small"}
          icon={showSearchbar ? close : search}
          ariaLabel={"search"}
          onClick={() => handleSearchbar(!showSearchbar)}
        />
      ) : undefined}
    </React.Fragment>
  );
};

export default Searchbar;
